import "./src/styles/global.css"
import "./src/styles/solutions.css"
import React from "react"
import { Analytics } from "@vercel/analytics/react"

// Vercel Web Analytics — privacy-first (no cookies, no consent banner required),
// a tiny deferred script loaded only in production. Renders nothing itself, so
// it has no layout/Lighthouse cost. Requires "Web Analytics" to be enabled in
// the Vercel project dashboard for data to start flowing.
export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <Analytics />
  </>
)
